import React from "react";

const HistoryItemsMobileWrapper = (props) => {
  return (
    <div className="fixed-bottom">
      <div>
        <div className="history-mobile-wrapper fixed-bottom ">
          <div className="history-container">
            <div className="row container-div m-0 align-items-center no no-gutters mobile-history-hedder">
              <div className="col-10 vh-plate">{props.infoStr}</div>
              <div className="col-2" style={{ textAlign: "right" }}></div>
            </div>
            <div id="collapseExample" className="list-wrapper px-4 show ">
              {props.children}
            </div>

            <div className="row container-div m-0 align-items-center no no-gutters mobile-history-hedder">
              <div className="col-2">
                <div>{props.showButton}</div>
              </div>


              <div className="col-8">{props.historyDate}</div>
              <div className="col-1" style={{ textAlign: "right" }}>
                {props.close}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryItemsMobileWrapper;
